import { render } from "./UserEmailAccountDeleteDialog.vue?vue&type=template&id=3950ec06"
import script from "./UserEmailAccountDeleteDialog.vue?vue&type=script&lang=js"
export * from "./UserEmailAccountDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__